module.exports = __webpack_public_path__ + "static/img/log.a118d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/log.png
// module id = ooco
// module chunks = 2